import { navLinks } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-background-800">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="text-xl font-heading text-white mb-3">桃子视频</div>
            <p className="text-sm text-background-300 leading-relaxed">
              涵盖红桃视频、黑桃视频、桃花视频、红杏视频、糖心视频、豆花视频等情感色彩影视资源，
              免费高清在线播放电影电视剧，糖心豆花等视频不卡顿。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-heading text-white mb-4">快速导航</h3>
            <div className="flex flex-col gap-2">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-heading text-white mb-4">热门频道</h3>
            <div className="flex flex-col gap-2">
              {['红桃剧场', '黑桃悬疑', '桃花综艺', '红杏剧场', '糖心动漫', '豆花纪录片'].map((ch) => (
                <a key={ch} href="#index" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                  {ch}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-heading text-white mb-4">合作伙伴</h3>
            <p className="text-xs text-background-400">合作站点信息后续更新，敬请期待</p>
          </div>
        </div>

        <div className="border-t border-background-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; 2026 桃子视频 - 免费高清在线观影平台。本站内容仅供学习交流，请支持正版。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">回到顶部</a>
            <a href="#faq" className="text-xs text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">常见问题</a>
            <a href="#contact" className="text-xs text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}